import React from 'react';
import { FormattedMessage, InjectedIntl, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { COLORS } from '../constants/styles';

interface IRadioButtonProps {
    id: string;
    disabled?: boolean;
    label: FormattedMessage.MessageDescriptor | string;
    intl: InjectedIntl;
    value?: boolean;
    required?: boolean;
    tooltipText?: FormattedMessage.MessageDescriptor | string;
    onCheck: () => void;
    qaId?: string;
}

interface IRadioButtonState {
    checked: boolean;
}

const RadioButtonWrapper = styled.div`
    cursor: ${(props: { checked: boolean }) => (props.checked ? 'not-allowed' : 'pointer')};
    input {
        visibility: hidden;
    }
    .switch {
        display: flex;
        align-items: center;
        user-select: none;
    }
    .switch input[type='checkbox'] {
        cursor: pointer;
        opacity: 0;
        -webkit-appearance: none;
        appearance: none;
        position: absolute;
        box-sizing: border-box;
        padding: 0;
    }
    .switch-ui {
        transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
            background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        position: relative;
        box-sizing: border-box;
        border-radius: 50rem;
        background-color: ${(props: { checked: boolean }) =>
            props.checked ? '#f53a3a' : '#B6B6B6'};
        height: 20px;
        width: 36px;
    }
    .switch-knob {
        position: absolute;
        top: 2px;
        right: ${(props: { checked: boolean }) => (props.checked ? '2px' : 'auto')};
        left: ${(props: { checked: boolean }) => (props.checked ? 'auto' : '2px')};
        border-radius: 50rem;
        height: 1rem;
        width: 1rem;
        background: ${COLORS.white};
    }
    #switchLabel {
        padding-left: 5px;
    }
`;

class RadioButton extends React.Component<IRadioButtonProps, IRadioButtonState> {
    private readonly ID: string;

    constructor(props: IRadioButtonProps) {
        super(props);
        const { id, value } = this.props;

        this.state = {
            checked: Boolean(value),
        };
        this.ID = id;
        this.onClick = this.onClick.bind(this);
    }

    public render() {
        const { label, intl, qaId } = this.props;
        const labelMessage = typeof label === 'string' ? label : intl.formatMessage(label);
        const { checked } = this.state;

        return (
            <RadioButtonWrapper
                checked={checked}
                onClick={this.onClick}
                data-qa-id={`${qaId}-radio-button`}
                tabIndex={0}
                aria-labelledby="switchLabel"
            >
                <div className="switch" role="switch" aria-checked="false">
                    <input role="switch" type="checkbox" id={this.ID} />
                    <span className="switch-ui">
                        <span className="switch-knob"></span>
                    </span>
                    <label htmlFor={this.ID} id="switchLabel">
                        {labelMessage}
                    </label>
                </div>
            </RadioButtonWrapper>
        );
    }

    private onClick() {
        const { onCheck } = this.props;
        const { checked } = this.state;

        if (!checked && onCheck) {
            this.setState({
                checked: true,
            });
            onCheck();
        }
    }
}

export default injectIntl(RadioButton);
